import * as React from "react";
import { keyframes } from "@mui/material";

export interface TutorialContextContent {
  tutorialPage: string | undefined;
  tutorialTitle: string;
  setTutorialPage: React.Dispatch<React.SetStateAction<string | undefined>>;
  updateTutorialState: (title: string, index: number) => void;
}

export const TutorialContext = React.createContext<TutorialContextContent | undefined>(undefined);

export const customTooltipAppearing = keyframes`0% {opacity: 0} 100% {opacity: 1}`;
